import { Tab } from "@headlessui/react";
import {
  ExploreFilterItem,
  ExploreFilterSchemaFields,
} from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import classNames from "classnames";
import { useEffect, useState } from "react";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

interface Props<T> {
  items: ExploreFilterItem<T>[];
  filterName: ExploreFilterSchemaFields;
  checkAllSelected?: boolean;
}
// eslint-disable-next-line no-unused-vars
function SelectBox<T>({
  items,
  filterName,
  checkAllSelected = true,
}: Props<string>) {
  const { addFilter, removeFilterByKey } = useExplore();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { activeFilters } = useExplorePreloadedData();

  const selectedActiveFilter = activeFilters
    ? activeFilters[filterName]?.filter_value || []
    : [];
  useEffect(() => {
    const isAllSelected = items.every(
      (item) =>
        selectedActiveFilter.findIndex(
          (filterSelected) => filterSelected.id === item.name
        ) !== -1
    );
    setSelectedIndex(
      isAllSelected && checkAllSelected
        ? 0
        : items.findIndex(
            (item) =>
              selectedActiveFilter.findIndex(
                (filterSelected) => filterSelected.id === item.name
              ) !== -1
          ) + 1 || 0
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, activeFilters]);
  const handleOnChange = async (
    filterValue: string | null,
    name: string = ""
  ) => {
    if (filterValue)
      addFilter({
        filterName: filterName,
        value: filterValue,
        name,
        isSingle: true,
        withReplace: true,
      });
    else removeFilterByKey(filterName);
  };
  return (
    <Tab.Group selectedIndex={selectedIndex}>
      <Tab.List className="border rounded-md border-fds-brand flex justify-between items-center">
        <>
          <Tab
            className={({ selected }) =>
              classNames(
                "py-2.5 flex justify-center w-full box-content rounded-r-md border-l border-l-fds-brand",
                selected && "bg-fds-brand-light "
              )
            }
            onClick={() => {
              handleOnChange(null);
            }}
          >
            <p className="text-fds-brand font-medium text-xs">همه</p>
          </Tab>
          {items.map((tItem, idx) => (
            <Tab
              key={idx}
              className={({ selected }) =>
                classNames(
                  "py-2.5 flex justify-center w-full box-content ",
                  selected && "bg-fds-brand-light ",
                  idx !== items.length - 1 && "border-l border-l-fds-brand",
                  idx === items.length - 1 ? "rounded-l-md" : ""
                )
              }
              onClick={() => {
                handleOnChange(tItem.name, tItem.persian_name);
              }}
            >
              <p className="text-fds-brand font-medium text-xs">
                {tItem.persian_name}
              </p>
            </Tab>
          ))}
        </>
      </Tab.List>
    </Tab.Group>
  );
}

export default SelectBox;
